import React, { useState, useEffect } from 'react';
import useWeather from "../hooks/useWeather";


const Boutton = ({ text, onClick, text_after, variant }) => {
  const variants = {
    yellow: 'bg-yellow-500 hover:bg-yellow-600 text-black',
    red: 'bg-red-500 hover:bg-red-600 text-white'
  };
  
  return (
    <button 
      onClick={onClick}
      className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${variants[variant] || 'bg-blue-500 hover:bg-blue-600 text-white'}`}
    >
      {text}
    </button>
  );
};

const SynapseNews = ({ articles, onClose, backChoice, guerres, playerCountry }) => {
    const [headerOpacity, setHeaderOpacity] = useState(0.95);
    const { temperature: currentTemp, description, min, max, lastUpdate } = useWeather();
    const [showSidebar, setShowSidebar] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            setHeaderOpacity(scrolled > 50 ? 0.98 : 0.95);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                onClose?.();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    // Suppression de l'ancien rafraîchissement aléatoire de la température

    const handleAIBadgeClick = (e) => {
        e.target.style.transform = 'scale(1.05)';
        setTimeout(() => {
            e.target.style.transform = 'scale(1)';
        }, 150);
    };

    const sectionStyles = {
        background: 'rgba(30, 41, 59, 0.4)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(59, 130, 246, 0.1)',
        borderRadius: '16px',
        padding: '2rem',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
    };

    const highlightCountry = (text) => {
        if (!playerCountry || !text) return text;
        const escaped = playerCountry.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escaped})`, 'gi');
        return text.split(regex).map((part, i) =>
            part.toLowerCase() === playerCountry.toLowerCase()
                ? <span key={i} className="font-bold text-yellow-300">{part}</span>
                : part
        );
    };

     return (
        <div className="min-h-screen bg-slate-900 text-slate-200">
            {articles.map((newspaper) => (
                <div key={newspaper.year} className="min-h-screen"
                    style={{
                        background: 'linear-gradient(135deg, #0c1017 0%, #1a1f2e 50%, #0f1419 100%)',
                        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif"
                    }}>

                    {/* Mobile Header */}
                    <header
                        className="sticky top-0 z-50 px-4 py-3 border-b border-blue-500/20"
                        style={{
                            background: `rgba(15, 20, 25, ${headerOpacity})`,
                            backdropFilter: 'blur(20px)'
                        }}
                    >
                        {/* Mobile Layout */}
                        <div className="flex items-center justify-between md:hidden">
                            <div className="flex items-center gap-2">
                                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center font-bold text-white text-sm">
                                    SN
                                </div>
                                <div>
                                    <div className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                        SYNAPSE
                                    </div>
                                    <div className="text-xs text-slate-500 -mt-1">{newspaper.year}</div>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <button 
                                    onClick={() => setShowSidebar(!showSidebar)}
                                    className="p-2 bg-blue-500/20 rounded-lg text-blue-400"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                </button>
                                <button 
                                    onClick={onClose}
                                    className="p-2 bg-red-500/20 rounded-lg text-red-400"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {/* Desktop Layout */}
                        <div className="hidden md:flex items-center justify-between max-w-7xl mx-auto px-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center font-bold text-white text-xl">
                                    SN
                                </div>
                                <div>
                                    <div className="text-3xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                        SYNAPSE NEWS
                                    </div>
                                    <div className="text-sm text-slate-500 -mt-1">Ce que l'algorithme autorise à diffuser</div>
                                </div>
                            </div>
                            <div className="flex items-center gap-4">
                                <div className="text-3xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                    {newspaper.year}
                                </div>
                                <Boutton
                                    text="ARTICLES"
                                    onClick={backChoice}
                                    text_after="HISTORIQUE"
                                    variant="yellow"
                                />
                                <Boutton
                                    text="x FERMER"
                                    onClick={onClose}
                                    text_after="← Retour"
                                    variant="red"
                                />
                            </div>
                        </div>
                    </header>

                    {/* War Banner */}
                    {guerres?.length > 0 && (
                        <div className="bg-gray-900 text-white overflow-hidden h-8 flex items-center">
                            <div className="animate-marquee whitespace-nowrap">
                                {guerres.map((guerre, index) => (
                                    <span key={index} className="mx-4 inline-block text-sm">
                                        <span className="text-green-600">⚔️</span>
                                        <span className="text-green-400">✅{guerre.Vainqueur}✅</span> vs{" "}
                                        <span className="text-red-400">❌{guerre.Perdant}❌</span>
                                        <span className="text-blue-400"> - {guerre.Territoire}</span>
                                        <span className="text-blue-400"> ☠️{guerre.perte_population}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Mobile Sidebar Overlay */}
                    {showSidebar && (
                        <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setShowSidebar(false)}>
                            <div 
                                className="fixed right-0 top-0 h-full w-80 bg-slate-900 overflow-y-auto transform transition-transform"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="p-4 border-b border-blue-500/20">
                                    <div className="flex items-center justify-between">
                                        <h2 className="text-lg font-bold">Infos Live</h2>
                                        <button 
                                            onClick={() => setShowSidebar(false)}
                                            className="p-1 text-slate-400"
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <SidebarContent currentTemp={currentTemp} description={description} min={min} max={max} lastUpdate={lastUpdate} newspaper={newspaper} />
                            </div>
                        </div>
                    )}

                    {/* Main Content Container */}
                    <div className="flex">
                        {/* Articles Content */}
                        <main className="flex-1 p-4 md:p-8 space-y-6">
                            {/* Quick Stats for Mobile */}
                            <div className="md:hidden bg-slate-800/40 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4">
                                <div className="flex items-center justify-between mb-3">
                                    <h3 className="font-semibold text-slate-200 flex items-center gap-2">
                                        🌤️ Couëron
                                    </h3>
                                    <div className="text-2xl font-bold text-yellow-400">{currentTemp ?? '--'}°</div>
                                </div>
                                <div className="grid grid-cols-2 gap-2 text-xs">
                                    <div className="bg-slate-700/30 p-2 rounded text-center">
                                        <div className="text-orange-400 font-semibold">+1.8°C</div>
                                        <div className="text-slate-500">Global</div>
                                    </div>
                                    <div className="bg-slate-700/30 p-2 rounded text-center">
                                        <div className="text-green-400 font-semibold">+245%</div>
                                        <div className="text-slate-500">#EspaceEurope</div>
                                    </div>
                                </div>
                            </div>

                            {/* Hero Article */}
                            <article className="bg-slate-800/40 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4 md:p-6 relative overflow-hidden">
                                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-green-500"></div>
                                
                                <div className="flex items-center gap-2 mb-3">
                                    <div 
                                        className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-blue-500 px-2 py-1 rounded-full text-xs font-semibold text-white cursor-pointer"
                                        onClick={handleAIBadgeClick}
                                    >
                                        <span>🤖</span>
                                        <span className="hidden sm:inline">Rédigé par IA Nexus</span>
                                        <span className="sm:hidden">IA</span>
                                    </div>
                                    <div className="flex items-center gap-1 text-xs text-slate-500">
                                        <span>🔥</span>
                                        <span>À la une</span>
                                    </div>
                                </div>

                                <h1 className="text-xl md:text-3xl font-bold mb-3 md:mb-4 leading-tight bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                    {highlightCountry(newspaper.headlineTitle)}
                                </h1>

                                <p className="text-slate-300 mb-4 text-sm md:text-base leading-relaxed">
                                    {highlightCountry(newspaper.headline)}
                                </p>
                                
                                <div className="flex flex-wrap items-center gap-2 md:gap-4 text-xs md:text-sm text-slate-500">
                                    <span className="flex items-center gap-1">
                                        <span>🕒</span>
                                        <span>2h</span>
                                    </span>
                                    <span className="bg-blue-500/10 px-2 py-1 rounded text-blue-500 flex items-center gap-1">
                                        <span>📖</span>
                                        <span>3 min</span>
                                    </span>
                                    <span className="flex items-center gap-1">
                                        <span>🌍</span>
                                        <span className="hidden sm:inline">International</span>
                                        <span className="sm:hidden">Int.</span>
                                    </span>
                                </div>
                            </article>

                            {/* Mobile Ad Banner */}
                            <div className="bg-gradient-to-r from-slate-800 to-slate-700 border border-blue-500/20 rounded-xl p-4 text-center text-slate-400 relative overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/5 to-transparent animate-pulse"></div>
                                <div className="relative">
                                    <div className="text-sm font-semibold mb-1">PUBLICITÉ</div>
                                    <div className="text-xs">Innovations technologiques</div>
                                </div>
                            </div>

                            {/* News Sections */}
                            <article className="bg-slate-800/40 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4 md:p-6 hover:border-blue-500/40 transition-all">
                                <div className="flex items-center justify-between mb-3">
                                    <div className="flex items-center gap-2">
                                        <span className="text-lg">🚨</span>
                                        <h2 className="text-lg md:text-xl font-bold text-slate-100">Faits divers</h2>
                                    </div>
                                    <div 
                                        className="bg-gradient-to-r from-green-500 to-blue-500 px-2 py-1 rounded-full text-xs text-white cursor-pointer"
                                        onClick={handleAIBadgeClick}
                                    >
                                        🤖 IA
                                    </div>
                                </div>
                                
                                <h3 className="text-base md:text-xl font-semibold text-slate-200 mb-3 leading-tight">
                                    {highlightCountry(newspaper.sectionDiversTitle)}
                                </h3>

                                <p className="text-slate-300 mb-4 text-sm md:text-base leading-relaxed">
                                    {highlightCountry(newspaper.sectionDivers)}
                                </p>
                                
                                <div className="flex flex-wrap items-center gap-2 md:gap-4 text-xs md:text-sm text-slate-500">
                                    <span>🕒 6h</span>
                                    <span className="bg-blue-500/10 px-2 py-1 rounded text-blue-500">📖 2 min</span>
                                    <span>🚑 Société</span>
                                </div>
                            </article>

                            <article className="bg-slate-800/40 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4 md:p-6 hover:border-blue-500/40 transition-all">
                                <div className="flex items-center justify-between mb-3">
                                    <div className="flex items-center gap-2">
                                        <span className="text-lg">🌍</span>
                                        <h2 className="text-lg md:text-xl font-bold text-slate-100">En bref dans le monde</h2>
                                    </div>
                                    <div 
                                        className="bg-gradient-to-r from-green-500 to-blue-500 px-2 py-1 rounded-full text-xs text-white cursor-pointer"
                                        onClick={handleAIBadgeClick}
                                    >
                                        🤖 IA
                                    </div>
                                </div>
                                
                                <h3 className="text-base md:text-xl font-semibold text-slate-200 mb-3 leading-tight">
                                    {highlightCountry(newspaper.sectionBrefTitle)}
                                </h3>

                                <p className="text-slate-300 mb-4 text-sm md:text-base leading-relaxed">
                                    {highlightCountry(newspaper.sectionBref)}
                                </p>
                                
                                <div className="flex flex-wrap items-center gap-2 md:gap-4 text-xs md:text-sm text-slate-500">
                                    <span>🕒 8h</span>
                                    <span className="bg-blue-500/10 px-2 py-1 rounded text-blue-500">📖 2 min</span>
                                    <span>🌐 International</span>
                                </div>
                            </article>

                            {/* Mobile Stats */}
                            <div className="md:hidden bg-slate-800/40 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4">
                                <h3 className="font-semibold mb-3 text-slate-100 flex items-center gap-2">
                                    <span>⚡</span>
                                    Stats Live
                                </h3>
                                <div className="text-sm text-slate-300">
                                    {highlightCountry(newspaper.sectionEliminations)}
                                </div>
                            </div>
                        </main>

                        {/* Desktop Sidebar */}
                        <aside className="hidden lg:block w-80 sticky top-16 h-fit">
                            <div className="bg-slate-900/95 backdrop-blur-xl border-l border-blue-500/20 h-full">
                                <div className="p-6 border-b border-blue-500/20">
                                    <h2 className="text-xl font-bold text-slate-100">Informations Live</h2>
                                </div>
                                <SidebarContent currentTemp={currentTemp} description={description} min={min} max={max} lastUpdate={lastUpdate} newspaper={newspaper} />
                            </div>
                        </aside>
                    </div>

                    {/* Footer */}
                    <footer className="border-t border-blue-500/20 mt-8 py-8 px-4 bg-slate-900/80">
                        <div className="max-w-7xl mx-auto text-center">
                            <div className="text-xl md:text-2xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent mb-4">
                                NEXUS
                            </div>
                            <p className="text-slate-500 mb-4 text-sm md:text-base">
                                L'information augmentée par l'intelligence artificielle.
                            </p>
                            <div className="flex flex-wrap justify-center gap-4 mb-4 text-xs md:text-sm">
                                <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">À propos</a>
                                <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">Notre IA</a>
                                <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">Contact</a>
                            </div>
                            <p className="text-slate-500 text-xs">
                                © 2025 NEXUS News. Propulsé par l'IA éthique.
                            </p>
                        </div>
                    </footer>

                    <style>{`
                        @keyframes marquee {
                            0% { transform: translateX(100%); }
                            100% { transform: translateX(-100%); }
                        }
                        .animate-marquee {
                            animation: marquee 30s linear infinite;
                        }
                        @keyframes shimmer {
                            0% { transform: translateX(-100%); }
                            100% { transform: translateX(100%); }
                        }
                    `}</style>
                </div>
            ))}
        </div>
    );
};

// Sidebar Content Component
const SidebarContent = ({ currentTemp, description, min, max, lastUpdate, newspaper }) => (
    <div className="p-6 space-y-6">
        {/* Weather Widget */}
        <div className="bg-slate-800/60 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4 text-center">
            <h3 className="text-lg font-bold mb-3 text-slate-100 flex items-center justify-center gap-2">
                Météo - Couëron
            </h3>
            <div className="text-3xl font-bold mb-2 bg-gradient-to-r from-yellow-500 to-red-500 bg-clip-text text-transparent">
                {currentTemp ?? '--'}°
            </div>
            <p className="text-slate-400 mb-3">{description}</p>
            <div className="flex justify-between text-slate-500 text-sm bg-slate-800/30 rounded-lg p-2">
                <span>Min: {min ?? '--'}°</span>
                <span>Max: {max ?? '--'}°</span>
            </div>
            <div className="mt-3 text-xs text-slate-500">🔄 Mise à jour: {lastUpdate ? lastUpdate.toLocaleTimeString('fr-FR') : '--'}</div>
        </div>

        {/* Climate Stats */}
        <div className="bg-slate-800/60 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4">
            <h3 className="text-lg font-bold mb-4 text-slate-100 flex items-center gap-2">
                <span>🌡️</span> Climat Global
            </h3>
            <div className="grid grid-cols-2 gap-3">
                <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                    <div className="text-lg font-bold text-orange-400">+1.8°C</div>
                    <div className="text-xs text-slate-500">Temp. moy.</div>
                </div>
                <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                    <div className="text-lg font-bold text-blue-400">+23cm</div>
                    <div className="text-xs text-slate-500">Océans</div>
                </div>
                <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                    <div className="text-lg font-bold text-red-400">-15%</div>
                    <div className="text-xs text-slate-500">Biodiversité</div>
                </div>
                <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                    <div className="text-lg font-bold text-purple-400">421ppm</div>
                    <div className="text-xs text-slate-500">CO2</div>
                </div>
            </div>
        </div>

        {/* Trending Topics */}
        <div className="bg-slate-800/60 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4">
            <h3 className="text-lg font-bold mb-4 text-slate-100 flex items-center gap-2">
                <span>📈</span> Tendances
            </h3>
            <div className="space-y-3">
                <div className="flex items-center justify-between p-2 bg-slate-800/30 rounded-lg">
                    <span className="text-sm text-slate-300">#EspaceEurope</span>
                    <span className="text-xs text-green-400 font-semibold">+245%</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-slate-800/30 rounded-lg">
                    <span className="text-sm text-slate-300">#TransportsNantes</span>
                    <span className="text-xs text-green-400 font-semibold">+189%</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-slate-800/30 rounded-lg">
                    <span className="text-sm text-slate-300">#DroneSecours</span>
                    <span className="text-xs text-green-400 font-semibold">+156%</span>
                </div>
            </div>
        </div>

        {/* Quick Stats */}
        <div className="bg-slate-800/60 backdrop-blur-lg border border-blue-500/20 rounded-xl p-4">
            <h3 className="text-lg font-bold mb-4 text-slate-100 flex items-center gap-2">
                <span>⚡</span> Stats Live
            </h3>
            <div className="text-sm text-slate-300">
                {newspaper.sectionEliminations}
            </div>
        </div>
    </div>
);

export default SynapseNews;